import React from 'react'

import { AsyncSelect } from '_zari/core'

import * as CuentaContableService from 'services/cuentaContable.service'

const Select2CuentaContable = ({ id, onlyAnalitica, onChange }) => {
  const loadCuentasSelect = React.useCallback(
    (inputValue, resolve) => {
      CuentaContableService.getCuentasContablesSelect({
        busqueda: inputValue,
        analitica: onlyAnalitica ? true : null
      })
        .then(({ data }) => resolve(data))
        .catch(() => resolve([]))
    },
    [onlyAnalitica]
  )

  return <AsyncSelect selectId={id} loadOptions={loadCuentasSelect} onChange={onChange} />
}

export default React.memo(Select2CuentaContable)
